import { BaseInterior } from './BaseInterior';
import { socketManager } from '../socket/SocketManager';

const TRUST_NAMES: Record<number, string> = {
  1: 'BRONZE', 2: 'ARGENT', 3: 'OR', 4: 'PLATINE', 5: 'DIAMANT',
};

const TRUST_COLORS: Record<number, string> = {
  1: '#cd7f32', 2: '#c0c0c0', 3: '#ffd700', 4: '#e5e4e2', 5: '#b9f2ff',
};

export class WholesalerInterior extends BaseInterior {
  render(): void {
    this.drawRoom(0x2a2a2a, 0x444444);
    this.addExitButton();
    this.addTitle(this.building.name);

    const { width, height } = this.scene.scale;
    const wi = this.stateData?.wholesalerInfo;

    if (!wi) {
      this.addLabel(80, height / 2, 'Le grossiste n\'est pas disponible.', '#ff4444', '16px');
      return;
    }

    let y = 100;
    const leftCol = 80;

    // Trust level
    const trustName = TRUST_NAMES[wi.trustLevel] ?? 'BRONZE';
    const trustColor = TRUST_COLORS[wi.trustLevel] ?? '#cd7f32';
    this.addLabel(leftCol, y, `Confiance: ${trustName}`, trustColor, '16px');
    y += 25;
    this.addLabel(leftCol, y, `XP: ${wi.xp}/${wi.nextLevelXp}`, '#aaaaaa', '12px');
    y += 18;
    this.drawProgressBar(leftCol, y, 200, 10, wi.nextLevelXp > 0 ? wi.xp / wi.nextLevelXp : 0, 0x333333, 0xffd700);
    y += 30;

    // Catalog
    this.addLabel(leftCol, y, '--- CATALOGUE ---', '#ff6b35', '14px');
    y += 25;

    for (const product of wi.availableProducts) {
      const locked = wi.trustLevel < product.requiredLevel;
      const lockStr = locked ? ' [VERROUILLE]' : '';
      const color = locked ? '#666666' : '#ffffff';

      this.addLabel(leftCol, y, `${product.name}${lockStr}`, color, '13px');
      y += 18;
      this.addLabel(leftCol + 20, y, `$${product.pricePerUnit}/u | Stock: ${product.inStock}`, '#aaaaaa', '11px');
      y += 22;

      if (!locked) {
        // Buy x10
        this.addButton(leftCol + 40, y, '[ x10 ]', '#4caf50', () => {
          socketManager.sendAction('BUY_FROM_WHOLESALER', {
            productType: product.drugType,
            quantity: 10,
            agreedPrice: product.pricePerUnit * 10,
          });
          this.refreshAfterAction();
        });

        // Buy x50
        this.addButton(leftCol + 120, y, '[ x50 ]', '#4caf50', () => {
          socketManager.sendAction('BUY_FROM_WHOLESALER', {
            productType: product.drugType,
            quantity: 50,
            agreedPrice: product.pricePerUnit * 50,
          });
          this.refreshAfterAction();
        });

        // Negotiate
        this.addButton(leftCol + 210, y, '[ Negocier ]', '#ffb347', () => {
          socketManager.sendAction('NEGOTIATE_PRICE', {
            productType: product.drugType,
            quantity: 50,
            offeredPrice: product.pricePerUnit * 50 * 0.85,
          });
          this.refreshAfterAction();
        });
        y += 30;
      }
      y += 10;
    }

    // Furniture
    this.graphics.fillStyle(0x5d4037, 1);
    for (let row = 0; row < 3; row++) {
      this.graphics.fillRect(width - 200, 120 + row * 80, 140, 15);
      this.graphics.fillStyle(0x8b4513, 1);
      for (let box = 0; box < 4; box++) {
        this.graphics.fillRect(width - 190 + box * 35, 100 + row * 80, 25, 20);
      }
      this.graphics.fillStyle(0x5d4037, 1);
    }
  }

  private refreshAfterAction(): void {
    socketManager.onceActionResult(() => {
      socketManager.sendAction('ENTER_BUILDING', { buildingId: this.building.id });
    });
  }

  bindEvents(): void {}
}
